import { PluginKey } from 'prosemirror-state';

export const MAX_MATCH = 500;
export const OPEN_REGEX = /^\/(\w+)?$/;

export const MAX_MENU_ITEMS = 8;
export const MENU_ITEM_HEIGHT = 56;
export const MENU_LIST_Y_PADDING = 16;

export const AddMenuPluginKey = new PluginKey('add-menu-plugin');
